(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/views/promos/default-promo-info-bar-clock.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/views/promos/default-promo-info-bar-clock.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.product_start_page=_svs.app.product_start_page||{};
_svs.app.product_start_page.templates=_svs.app.product_start_page.templates||{};
svs.app.product_start_page.templates.default_promo_info_bar_clock = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "  <div class=\"rounds-header-column\">\n    <i class=\"icon-default icon-clock icon-100\"></i>\n    <span class=\"align-middle\">"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</span>\n  </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":6,"column":7}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['components-app-product_start_page-default_promo_info_bar_clock'] = svs.app.product_start_page.templates.default_promo_info_bar_clock;
})(svs, Handlebars);


 })(window);